import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CardHeader from "@material-ui/core/CardHeader";
import { Split } from "../../utils/Split";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Bar, Line } from "react-chartjs-2";
import moment from "jalali-moment";
import { useMountAPI } from "../../hooks/APICall";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import { useEffect } from "react";
import {
  GREEN_PRIMRY,
  ERROR_COLOR,
  ORANGE_COLOR,
  BLUE_COLOR,
  BLUE_PRIMARY,
  WHITE,
} from "../../utils/const";

import { useSelector } from "react-redux";
import {
  createDates,
  getJsonDate,
  isBefore,
  jalaliToUtc,
} from "../../utils/TimeUtils";
import Loading from "../loading";
import ChartFilters from "../chartFilters";

const ConsumptionChart = (props) => {
  const categories = useSelector((state) => state.categories);

  const isLoading = useCustomState(true);
  const labels = useCustomState([]);
  const values = useCustomState([]);
  const cValues = useCustomState([]);
  const datasets = useCustomState([]);
  const category = useCustomState(
    categories.length > 0 ? categories[categories.length - 1] : null
  );

  const categoryChanged = (newValue) => {
    if (category.value === null) {
      category.handleChange(newValue);
    } else {
      if (newValue.id !== category.value.id) {
        category.handleChange(newValue);
      }
    }
  };

  /*
  begin: for filters
  */
  const numBefore = 13;
  const numAfter = 1;

  const tenBefore = moment().add(-numBefore, "day").locale("utc");
  const oneAfter = moment().add(numAfter, "day").locale("utc");

  const start = useCustomState(getJsonDate(tenBefore));
  const end = useCustomState(getJsonDate(oneAfter));

  const startError = useCustomState({ error: false, text: "" });

  const startChanged = (newDate) => {
    startError.handleChange({ error: false, text: "" });
    start.handleChange(newDate);
  };
  const endChanged = (newDate) => {
    startError.handleChange({ error: false, text: "" });
    end.handleChange(newDate);
  };

  const chartType = useCustomState("bar");
  const visualizationType = useCustomState("daily");

  const chartTypeChanged = (newValue) => {
    if (newValue !== chartType.value) {
      chartType.handleChange(newValue);
    }
  };

  const visualizationTypeChanged = (newValue) => {
    if (newValue !== visualizationType.value) {
      visualizationType.handleChange(newValue);
    }
  };
  /*
  end: for filters
  */

  const jStart = getJsonDate(moment().add(-numBefore, "day").locale("utc"));
  const jEnd = getJsonDate(moment().add(numAfter, "day").locale("utc"));
  const dates = createDates(jStart, jEnd);

  const consumptionUtils = {
    page: 1,
    count: 1000,
    isLoading: isLoading,
    projectId: null,
    userId: null,
    counterId: null,
    counterType: null,
    categoryId: category.value === null ? null : category.value.id,
    startTime: moment()
      .add(-numBefore, "day")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z"),
    endTime: moment()
      .add(numAfter, "day")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z"),
    labels: labels,
    values: values,
    dates: dates,
    cValues: cValues,
  };

  useMountAPI(fetchConsumption, consumptionUtils);

  useEffect(() => {
    if (!isLoading.value) {
      let color = GREEN_PRIMRY;
      if (category.value.name.includes("آب")) {
        color = BLUE_PRIMARY;
      } else if (category.value.name.includes("برق")) {
        color = ERROR_COLOR;
      } else if (category.value.name.includes("گاز")) {
        color = ORANGE_COLOR;
      } else {
        color = GREEN_PRIMRY;
      }

      const colors =
        visualizationType.value === "daily"
          ? values.value.map((value, index) => {
              if (value > 0) {
                return color;
              } else {
                return WHITE;
              }
            })
          : cValues.value.map((value, index) => {
              if (value > 0) {
                return color;
              } else {
                return WHITE;
              }
            });

      let label;

      if (visualizationType.value === "daily") {
        label =
          "مقدار مصرف " +
          category.value.name +
          " (بر حسب " +
          category.value.units[category.value.selectedUnitIdx] +
          ")";
      } else {
        label =
          "مقدار مصرف تجمعی " +
          category.value.name +
          " (بر حسب " +
          category.value.units[category.value.selectedUnitIdx] +
          ")";
      }

      const d = [
        {
          label: label,
          data:
            visualizationType.value === "daily"
              ? values.value.map((value, index) => Math.round(value))
              : cValues.value.map((value, index) => Math.round(value)),
          backgroundColor: colors,
          borderColor: colors,
          fill: false,
          barThickness: "flex",
          maxBarThickness: 48,
          minBarLength: 18,
        },
      ];
      datasets.handleChange(d);
    }
  }, [isLoading.value, visualizationType.value]);

  const data = {
    labels: labels.value,
    datasets: datasets.value,
  };

  const options = {
    legend: { labels: { fontFamily: "Vazir" }, rtl: false },
    scales: {
      yAxes: [
        {
          ticks: {
            // fontSize: 40
            fontFamily: "Vazir",
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              return Split(convertNumbers(label));
            },
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontFamily: "Vazir",
            userCallback: (label, index, labels) => {
              return convertNumbers(label);
            },
          },
          offset: true,
        },
      ],
    },
    tooltips: {
      bodyFontFamily: "Vazir",
      // mode: 'label',
      callbacks: {
        title: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return convertNumbers(data.labels[indice]);
        },
        label: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return (
            `مصرف در ${tooltipItem.xLabel}` +
            ": " +
            convertNumbers(
              Split(data.datasets[tooltipItem.datasetIndex].data[indice])
            ) +
            ""
          );
        },
      },
    },
  };

  const applyFilters = (data) => {
    if (!isBefore(start.value, end.value)) {
      startError.handleChange({
        error: true,
        text: "تاریخ شروع انتخاب شده باید قبل از تاریخ پایان باشد.",
      });
      return;
    }
    isLoading.handleChange(true);
    chartTypeChanged(data.chartType);
    categoryChanged(data.category);
    const fromDate = jalaliToUtc(start.value);
    const toDate = jalaliToUtc(end.value, false);
    const consumptionUtils = {
      page: 1,
      count: 1000,
      isLoading: isLoading,
      projectId: null,
      userId: null,
      counterId: null,
      counterType: null,
      categoryId: data.category.id,
      startTime: fromDate.format("YYYY-MM-DDT00:00:00Z"),
      endTime: toDate.format("YYYY-MM-DDT23:59:59Z"),
      labels: labels,
      values: values,
      cValues: cValues,
      dates: createDates(start.value, end.value),
    };
    fetchConsumption(consumptionUtils);
  };

  const renderChart = () => {
    if (chartType.value === "line") {
      return <Line options={options} data={data} />;
    } else {
      return <Bar options={options} data={data} />;
    }
  };

  const renderContent = () => {
    if (!isLoading.value) {
      return (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {renderChart()}
        </Grid>
      );
    } else {
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ height: "260px", position: "relative" }}
        >
          <Loading />
        </Grid>
      );
    }
  };

  return (
    <div style={{ paddingRight: "8px", paddingLeft: "8px" }}>
      <Card
        style={{
          marginTop: "16px",
          backgroundColor: "white",
          paddingBottom: "24px",
          paddingTop: "8px",
          paddingRight: "24px",
          paddingLeft: "24px",
          overflow: "visible",
        }}
      >
        <CardHeader
          style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
          title={convertNumbers("میزان مصرف کل کنتورها")}
        />

        <Grid container>
          <ChartFilters
            start={start}
            startError={startError}
            startChanged={startChanged}
            end={end}
            endChanged={endChanged}
            renderChartType={true}
            chartTypeChanged={chartTypeChanged}
            renderCategories={true}
            categories={categories}
            categoryChanged={categoryChanged}
            applyFilters={applyFilters}
            renderVisualizationType={true}
            visualizationTypeChanged={visualizationTypeChanged}
          />
          {renderContent()}
        </Grid>
      </Card>
    </div>
  );
};

export default ConsumptionChart;

const renderNoData = (labels, values, cValues, dates) => {
  labels.handleChange(dates);
  const V = [];
  dates.map((d, idx) => {
    V.push(0);
  });
  values.handleChange(V);
  cValues.handleChange(V);
};

const prepareChartData = (
  consumptions,
  labels,
  values,
  cValues,
  expectedDates
) => {
  if (Array.isArray(consumptions)) {
    renderNoData(labels, values, cValues, expectedDates);
    return;
  } else {
    const cumulativeConsumption = consumptions.cumulative_consumptions;
    delete consumptions.cumulative_consumptions;
    delete consumptions.average;
    delete consumptions.total;
    const dates = Object.keys(consumptions);
    const jDates = [];
    const jConsumptions = {};
    dates.map((d, idx) => {
      const jDate = moment(d).locale("fa").format("YYYY/MM/DD");
      jDates.push(jDate);
      jConsumptions[jDate] = consumptions[d];
    });
    const CV = [];
    const CCV = [];
    let cumcons = cumulativeConsumption;
    expectedDates.map((ed, idx) => {
      if (jDates.includes(ed)) {
        CV.push(jConsumptions[ed]);
        cumcons = cumcons + jConsumptions[ed];
        CCV.push(cumcons);
      } else {
        CV.push(0);
        CCV.push(cumcons);
      }
    });
    labels.handleChange(expectedDates);
    values.handleChange(CV);
    cValues.handleChange(CCV);
  }
};

const fetchConsumption = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const projectId = utils.projectId;
  const userId = utils.userId;
  const counterId = utils.counterId;
  const counterType = utils.counterType;
  const categoryId = utils.categoryId;
  const startTime = utils.startTime;
  const endTime = utils.endTime;
  const labels = utils.labels;
  const values = utils.values;
  const cValues = utils.cValues;
  const dates = utils.dates;

  if (!categoryId) {
    renderNoData(labels, values, cValues, dates);
    isLoading.handleChange(false);
    return;
  } else {
    const data = {
      page: page,
      count: count,
      project_id: projectId,
      user_id: userId,
      water_meters: counterId,
      type_id: counterType,
      tag_id: categoryId,
      start_time: startTime,
      end_time: endTime,
    };

    Call("POST", "watermeters/admin/getAll/consumption/date", data)
      .then((response) => {
        if (response.data.code === 200) {
          const consumptions = response.data.data;
          prepareChartData(consumptions, labels, values, cValues, dates);
        }
        isLoading.handleChange(false);
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
        }
        isLoading.handleChange(false);
      });
  }
};
